
export const validateWordCount = (value) => {
    const wordCount = value.trim().split(/\s+/).length;
    return wordCount <= 150 || "وصف الطلب يجب ألا يتجاوز 150 كلمة";
};